import ApiResourceManager from '../ApiResourceManager';

export default class WebsiteStudioManager extends ApiResourceManager {
  create = async (data) =>
    this.request({
      method: 'POST',
      url: '/website-studio',
      data,
    });

  get = async () =>
    this.request({
      method: 'GET',
      url: '/website-studio',
    });

  delete = async () =>
    this.request({
      method: 'DELETE',
      url: '/website-studio',
    });
}
